import './PortfolioSnapshot.scss';

import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import AccountLayoutHeader from 'components/layouts/AccountLayoutHeader/AccountLayoutHeader';
import AdvisorySnapshot from './AdvisorySnapshot';
import SelfManagedSnapshot from './SelfManagedSnapshot';
import { getProductPerformance } from 'services/Rest';
import { getAccounts } from 'state/account/AccountSelectors';

const PortfolioSnapshot = ({ accounts }) => {
  useEffect(() => {
    getProductPerformance(accounts);
  }, [accounts]);

  return (
    <div className="portfolio-snapshot">
      <AccountLayoutHeader
        text="Portfolio Snapshot"
        link="/accounts"
        detailText="Portfolio Details"
        isSubheader={false}
      />

      <AdvisorySnapshot />
      <SelfManagedSnapshot />
    </div>
  );
};

const mapStateToProps = (state) => ({
  accounts: getAccounts(state)
});

export default connect(mapStateToProps)(PortfolioSnapshot);
